import { gql } from "@urql/svelte";

export const USER_INFO = gql`
    query UserInfoQuery {
        userInfo {
            id
            firstname
            lastname
        }
    }
`;

export const USER_LOGOUT = gql`
    query UserLogoutQuery {
        logout
    }
`;
